import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { isSoldOut, isWaitlisted, isLowQuantity } from 'lib/utils/product'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import Badge from 'components/common/badge'
import { BADGE_COLOR } from 'components/common/badge/const'
import LOCIZE_DATA from './const'

const getSizeLabelOfProduct = (
  item,
  localWaitlists,
  lowQuantity,
  t,
  soldOutNotifyMe,
  soldOutWaitlisted,
) => {
  let text = ''
  let colorBadge = ''

  if (isLowQuantity(item)) {
    text = hasLocizeTranslation(t, lowQuantity.key, lowQuantity.text).replace(
      '%s',
      item.stock.quantity,
    )
    colorBadge = BADGE_COLOR.desktopBanner
  }

  if (isSoldOut(item)) {
    text += isWaitlisted(item, localWaitlists)
      ? hasLocizeTranslation(t, soldOutWaitlisted.key, soldOutWaitlisted.text)
      : hasLocizeTranslation(t, soldOutNotifyMe.key, soldOutNotifyMe.text)
    colorBadge = isWaitlisted(item, localWaitlists)
      ? BADGE_COLOR.secondary
      : BADGE_COLOR.errorLight
  }

  return { text, colorBadge }
}

const SelectLabelItem = ({
  item,
  localWaitlists,
  t,
  isPhone,
  isComingSoon,
}) => {
  const {
    lowQuantity,
    soldOutNotifyMe,
    soldOutWaitlisted,
    comingSoonWaitlisted,
  } = LOCIZE_DATA
  const isSoldOutAndNotInWaitListed =
    isSoldOut(item) && !isWaitlisted(item, localWaitlists)
  const label = getSizeLabelOfProduct(
    item,
    localWaitlists,
    lowQuantity,
    t,
    soldOutNotifyMe,
    soldOutWaitlisted,
  )
  const isLabel = label.text !== ''
  const isComingSoonWaitlistedLabel = hasLocizeTranslation(
    t,
    comingSoonWaitlisted.key,
    comingSoonWaitlisted.text,
  )

  if (isPhone) {
    return isSoldOutAndNotInWaitListed ? (
      <div>
        {isLabel && !isComingSoon && (
          <Badge
            content={label.text}
            color={label.colorBadge}
            className="pdp__options-sold-out"
            contentClassName={clsx(Typo.caption)}
          />
        )}
      </div>
    ) : (
      <span className={clsx('pdp__options-label-wrapper', Typo.body2)}>
        {isLabel && (
          <Badge
            color={label.colorBadge}
            className="pdp__options-label"
            contentClassName={clsx(Typo.caption)}
            content={isComingSoon ? isComingSoonWaitlistedLabel : label.text}
          />
        )}
      </span>
    )
  }

  return isSoldOutAndNotInWaitListed ? (
    <span className={clsx('pdp__options-label-wrapper', Typo.body2)}>
      {item.size}
      {isLabel && !isComingSoon && (
        <Badge
          content={label.text}
          color={label.colorBadge}
          contentClassName={clsx(Typo.caption)}
          className={clsx('pdp__options-sold-out')}
        />
      )}
    </span>
  ) : (
    <span className={clsx('pdp__options-label-wrapper', Typo.body2)}>
      {item.size}
      {isLabel && (
        <Badge
          color={label.colorBadge}
          className="pdp__options-label"
          contentClassName={clsx(Typo.caption)}
          content={isComingSoon ? isComingSoonWaitlistedLabel : label.text}
        />
      )}
    </span>
  )
}

SelectLabelItem.defaultProps = {
  isComingSoon: false,
}

SelectLabelItem.propTypes = {
  localWaitlists: PropTypes.shape({}).isRequired,
  isPhone: PropTypes.bool.isRequired,
  isComingSoon: PropTypes.bool,
  item: PropTypes.shape({
    stock: PropTypes.shape({
      quantity: PropTypes.number,
      is_low_stock: PropTypes.bool,
      is_sold_out: PropTypes.bool,
    }),
    size: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(SelectLabelItem)
